import { Logger, ISettingsParam } from "tslog";

import { IS_PRODUCTION } from "./constants";
import { otelLogTransport } from "./otelLogTransport";

export const loggerConfig: ISettingsParam<unknown> = {
  // 3 is info. tslog treats minLevel as a floor, so debug and below stay off; the level
  // numbers are 0 silly, 1 trace, 2 debug, 3 info, 4 warn, 5 error, 6 fatal.
  minLevel: parseInt(process.env.NEXT_PUBLIC_LOGGER_LEVEL || "3"),
  maskValuesOfKeys: ["password", "passwordConfirmation", "credentials", "credential"],
  prettyLogTimeZone: IS_PRODUCTION ? "UTC" : "local",
  prettyErrorStackTemplate: "  • {{fileName}}\t{{method}}\n\t{{filePathWithLine}}", // default
  prettyErrorTemplate: "\n{{errorName}} {{errorMessage}}\nerror stack:\n{{errorStack}}", // default
  prettyLogTemplate: "{{hh}}:{{MM}}:{{ss}}:{{ms}} [{{logLevelName}}] ", // default with exclusion of `{{filePathWithLine}}`
  stylePrettyLogs: !IS_PRODUCTION,
  prettyLogStyles: {
    name: "yellow",
    dateIsoStr: "blue",
  },
  type: IS_PRODUCTION ? "json" : "pretty",
  // Declared here, not attached later: tslog copies this array into every sub-logger as it is
  // constructed, and cal builds them at module scope all over the codebase.
  attachedTransports: [otelLogTransport],
};

const logger = new Logger(loggerConfig);

export default logger;
